import React, { Component } from "react";
import { Container, Card, CardGroup, Button } from "react-bootstrap";
import gaming from "../files/gaming.png";
import map from "../files/map.png";
import antalya from "../files/antalya.png";

export default class Projects extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
	}
	collapse = () => {
		this.setState({ open: !this.state.open });
	};
	render() {
		const cards = [
			{
				src: gaming,
				title: "Focussed Attention Disorder",
				text:
					"This project was my senior project at university. It was a VR game for patients who suffer from Focussed Attention Disorder. I worked on its Web Application side mostly with React.js.",
				button: {
					url: "https://github.com/ErkinKurt/FocusedAttentionWeb",
					text: "Go to its github page",
				},
			},
			{
				src: map,
				title: "PARK@",
				text:
					"PARK@ is a mobile application that is developed with Flutter. Its purpose is finding parking lots that are available near the users. It is in development.",
			},
			{
				src: antalya,
				title: "Antalya Kartus",
				text:
					"This website is for Antalya Kartus Company and still in development. In the future it may be evolve to an e-commerce application..",
				button: {
					url: "https://sharp-perlman-faac6f.netlify.app/",
					text: "Go to antalyakartus.org",
				},
			},
		];
		return (
			<section className="projects" id="projects">
				<Container>
					<h1 className="mb-3">Projects</h1>
					<p className="mb-3">
						I have worked on many different projects. These are 3 of
						them:
					</p>
					<CardGroup>
						{cards.map((card) => (
							<Card key={card.title}>
								<Card.Img variant="top" src={card.src} />
								<Card.Body>
									<Card.Title>{card.title}</Card.Title>
									<Card.Text>{card.text}</Card.Text>
									{card.button ? (
										<Button
											href={card.button.url}
											target="_blank"
											rel="noopener noreferrer"
											variant="primary"
										>
											{card.button.text}
										</Button>
									) : (
										""
									)}
								</Card.Body>
							</Card>
						))}
					</CardGroup>
				</Container>
			</section>
		);
	}
}
